import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { reduxKey } from './constants';
import { BiStore } from './types';
import { logPageView } from './actions';

const actionHandlers = handleActions<BiStore, any>(
  {
    [logPageView.toString()]: (state, { payload }: ReturnType<typeof logPageView>) => {
      return {
        ...state,
        pageview: pick(payload, 'view', 'component', 'typeid', 'itemid'),
      };
    },
  },
  { pageview: {} as any }
);

export default {
  [reduxKey as string]: actionHandlers,
};
